"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStack = exports.Stack = exports.StackDirectionType = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var StackDirectionType;
(function (StackDirectionType) {
    StackDirectionType["VERTICAL"] = "vertical";
    StackDirectionType["HORIZONTAL"] = "horizontal";
})(StackDirectionType = exports.StackDirectionType || (exports.StackDirectionType = {}));
function Stack(props) {
    var children = props.children, gap = props.gap, testId = props.testId, _a = props.alignItems, alignItems = _a === void 0 ? 'initial' : _a, _b = props.justifyContent, justifyContent = _b === void 0 ? 'initial' : _b, _c = props.width, width = _c === void 0 ? 'auto' : _c, _d = props.height, height = _d === void 0 ? 'auto' : _d, _e = props.isFluid, isFluid = _e === void 0 ? false : _e, _f = props.direction, direction = _f === void 0 ? 'horizontal' : _f, justifyItems = props.justifyItems;
    if (!children)
        return null;
    var columnCount = React.Children.map(children, function (item) { return item; }).filter(function (el) { return !!el; }).length;
    return (React.createElement(exports.StyledStack, { direction: direction, gap: gap, isFluid: isFluid, columnCount: columnCount, alignItems: alignItems, justifyContent: justifyContent, width: width, height: height, "data-testid": testId, justifyItems: justifyItems }, children));
}
exports.Stack = Stack;
exports.StyledStack = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: grid;\n  ", "\n"], ["\n  display: grid;\n  ", "\n"])), function (props) {
    var direction = props.direction, columnCount = props.columnCount, isFluid = props.isFluid, gap = props.gap, alignItems = props.alignItems, justifyContent = props.justifyContent, justifyItems = props.justifyItems, height = props.height, width = props.width;
    var childSize = isFluid ? '1fr' : 'max-content';
    if (direction === 'horizontal') {
        return {
            alignItems: alignItems,
            height: height,
            justifyContent: justifyContent,
            justifyItems: justifyItems,
            gridAutoFlow: 'column',
            gridColumnGap: "".concat(gap, "px"),
            gridTemplateColumns: "repeat(".concat(columnCount, ", ").concat(childSize, ")"),
            width: width,
        };
    }
    return {
        gridTemplateRows: "repeat(".concat(columnCount, ", ").concat(childSize, ")"),
        gridAutoFlow: 'row',
        gridRowGap: "".concat(gap, "px"),
        alignItems: alignItems,
        justifyContent: justifyContent,
        justifyItems: justifyItems,
        height: height,
        width: width,
    };
});
var templateObject_1;
//# sourceMappingURL=index.js.map